import React from 'react'
import Layout from "../../Layout/Layout"
import StepsWrapper from "../../Layout/StepsWrapper/StepsWrapper"

const StepsLayout = ({children, tipo}) => {
    return (
        <Layout tipo={tipo}>
            <StepsWrapper>
            {children}
            </StepsWrapper>
        </Layout>
    )
}

export default StepsLayout
